import {useEffect, useRef} from "react";
import { Slide } from "@material-ui/core";
import '../styles.scss';
import useOnScreen from "../../common/componentVisibleHook";

const MenuPreviewCard = ({ img, position = 'center', threshold, slideDirection }) => {

  const ref = useRef();

  const isVisible = useOnScreen(ref, threshold);

  return (
    <div ref={ref}>
      <Slide in={isVisible} direction={slideDirection}>
        <div
          className='menu-preview-card'
          style={{
            backgroundImage: `url(${img})`,
            backgroundPosition: position,
          }}>
        </div>
      </Slide>
    </div>
  );
};

export default MenuPreviewCard;
